<pot-modal-layout [title]="title">
  @for (block of blocks; track block) {
    @switch (block.type) {
      @case (BlockType.paragraphs) {
        <pot-block-paragraph [data]="block.data" />
      }
      @case (BlockType.image) {
        <pot-block-image [data]="block.data" />
      }
      @case (BlockType.paragraphsCarousel) {
        <pot-block-paragraph-carousel [data]="block.data" />
      }
    }
  }
</pot-modal-layout>
